import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/Home'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/about',
          name: 'about',
          component: resolve => require(['@/view/About'], resolve),
          meta: {
            title: '关于我们'
          },
        },{
          path: '/school',
          name: 'school',
          component: resolve => require(['@/view/School'], resolve),
          meta: {
            title: '合作办学'
          },
        }, {
          path: '/kindergarten',
          name: 'kindergarten',
          component: resolve => require(['@/view/Kindergarten'], resolve),
          meta: {
            title: '小金星幼儿园'
          },
        }, {
          path: '/clover',
          name: 'clover',
          component: resolve => require(['@/view/Clover'], resolve),
          meta: {
            title: '小金星幼儿园'
          },
        }, {
          path: '/cubScout',
          name: 'cubScout',
          component: resolve => require(['@/view/CubScout'], resolve),
          meta: {
            title: '小金星幼童军'
          },
        },{
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/News'], resolve),
          meta: {
            title: '集团新闻'
          }
        },{
          path: '/newsDetail',
          name: 'newsDetail',
          component: resolve => require(['@/view/NewsDetail'], resolve),
          meta: {
            title: '新闻详情'
          }
        },{
          path: '/target',
          name: 'target',
          component: resolve => require(['@/view/Target'], resolve),
          meta: {
            title: '办学目标'
          }
        },{
          path: '/education',
          name: 'education',
          component: resolve => require(['@/view/Education'], resolve),
          meta: {
            title: '家园共育'
          }
        },{
          path: '/search',
          name: 'search',
          component: resolve => require(['@/view/Search'], resolve),
          meta: {
            title: '园所查找'
          }
        },{
          path: '/searchDetail',
          name: 'searchDetail',
          component: resolve => require(['@/view/SearchDetail'], resolve),
          meta: {
            title: '园所详情'
          }
        },{
          path: '/partner',
          name: 'partner',
          component: resolve => require(['@/view/Partner'], resolve),
          meta: {
            title: '专业合作'
          }
        },{
          path: '/job',
          name: 'job',
          component: resolve => require(['@/view/Job'], resolve),
          meta: {
            title: '加入我们'
          }
        },{
          path: '/contact',
          name: 'contact',
          component: resolve => require(['@/view/Contact'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        ,{
          path: '/richtext',
          name: 'richtext',
          component: resolve => require(['@/view/Richtext'], resolve),
          meta: {
            title: '联系我们'
          }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js